import {
  SidePanel,
  SidePanelHeader,
  SidePanelContent,
} from '../../organisms/SidePanel/SidePanel';

/**
 * Form side panel shell — reuses SidePanel animations with blurred backdrop.
 * @param {object} props
 * @param {boolean} props.isOpen - Whether the panel is open
 * @param {string} props.title - Header title
 * @param {string} props.containerId - Scroll container id for FormTabs
 * @param {boolean} [props.hasLiveSearch=false] - Two-column layout with independent scrolls
 * @param {() => void} props.onClose - Close handler (backdrop, escape, header)
 * @param {number} [props.stackDepth=0] - Stack depth for nested panels
 * @param {boolean} [props.showBackdrop=true] - Whether to show the closing backdrop
 * @param {() => void} [props.onExitComplete] - Called after the panel slide-out animation ends
 * @param {import('react').ReactNode} props.children - Form content (typically Form view)
 * @returns {JSX.Element | null} FormSidePanel component
 */
function FormSidePanel({
  isOpen,
  title,
  containerId,
  hasLiveSearch = false,
  onClose,
  onExitComplete,
  stackDepth = 0,
  showBackdrop = true,
  children,
}) {
  return (
    <SidePanel
      isOpen={isOpen}
      showBackdrop={showBackdrop}
      backdropBlur
      onClose={onClose}
      onExitComplete={onExitComplete}
      panelId={`${containerId}-dialog`}
      size="form"
      stackDepth={stackDepth}
      usePortal
    >
      <SidePanelHeader
        title={title}
        onClose={onClose ?? (() => {})}
      />
      <SidePanelContent
        id={hasLiveSearch ? undefined : containerId}
        variant="form"
        disableScroll={hasLiveSearch}
      >
        {children}
      </SidePanelContent>
    </SidePanel>
  );
}

export default FormSidePanel;
